import { scrollTo } from './browser';
import css from '@wix/da-ds/src/styles/variables.scss';
var siteHeaderHeight = parseInt(css['site-header-height']);
var siteHeaderHeightMobile = parseInt(css['site-header-height-mobile']);
function scrollElementToViewPortOffset(element, offset, scrollableAncestor, smoothScroll) {
    if (typeof window === 'undefined') {
        return;
    }
    var bounds = element.getBoundingClientRect();
    var ancestorOffset = scrollableAncestor
        ? scrollableAncestor.scrollTop
        : window.pageYOffset;
    var newY = Math.max(ancestorOffset - offset + bounds.top, 0);
    var options = {
        left: 0,
        top: newY,
        behavior: 'auto',
    };
    if (smoothScroll) {
        options.behavior = 'smooth';
    }
    scrollableAncestor
        ? scrollTo(scrollableAncestor, options)
        : scrollTo(window, options);
}
// we are conveniently assuming there's only vertical scrolling in here
export function scrollIntoViewWithHeader(element, isMobile, extraHeaderHeight, // in case there are extra sticky things to account for,
scrollableAncestor, smoothScroll, skipVisibilityCheck) {
    if (isMobile === void 0) { isMobile = false; }
    if (extraHeaderHeight === void 0) { extraHeaderHeight = 0; }
    if (typeof window === 'undefined') {
        return;
    }
    var headerHeight = (isMobile ? siteHeaderHeightMobile : siteHeaderHeight) + extraHeaderHeight;
    var bounds = element.getBoundingClientRect();
    // if it's already visible, nothing to do
    if (bounds.top >= headerHeight &&
        bounds.bottom <= window.innerHeight &&
        !skipVisibilityCheck) {
        return;
    }
    scrollElementToViewPortOffset(element, headerHeight, scrollableAncestor, smoothScroll);
}
// in cases when sticky stuff is just too much PITA, assume mid point is somewhat acceptable
export function scrollIntoViewInViewportCenter(element, isMobile, scrollableAncestor, smoothScroll) {
    if (isMobile === void 0) { isMobile = false; }
    if (typeof window === 'undefined') {
        return;
    }
    var viewPortHeight = window.innerHeight - (isMobile ? siteHeaderHeightMobile : siteHeaderHeight);
    var bounds = element.getBoundingClientRect();
    scrollElementToViewPortOffset(element, (viewPortHeight - bounds.height) / 2, scrollableAncestor, smoothScroll);
}
export function scrollIntoViewInViewportBottom(element, isMobile, offsetFromBottom, scrollableAncestor, smoothScroll) {
    if (isMobile === void 0) { isMobile = false; }
    if (offsetFromBottom === void 0) { offsetFromBottom = 0; }
    if (typeof window === 'undefined') {
        return;
    }
    var viewPortHeight = window.innerHeight - (isMobile ? siteHeaderHeightMobile : siteHeaderHeight);
    var bounds = element.getBoundingClientRect();
    scrollElementToViewPortOffset(element, viewPortHeight - bounds.height - offsetFromBottom, scrollableAncestor, smoothScroll);
}
//# sourceMappingURL=scrollIntoViewWithHeader.js.map